function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 109.6L141.7 0 0 109.6l41.3 32L0 173.5l141.7 109.9 141.7-109.9-41.3-31.9 41.4-32zM141.7 36.1l95.1 73.5-95.1 73.8-95.1-73.8 95.1-73.5zm95.1 137.5l-95.1 73.8-95.1-73.8 17.9-13.9 77.2 59.8 77.2-59.8 17.9 13.9z"
})));